/*
 MIT License
 Copyright (c) 2017 ANKO Technologies (http://ankosoftware.com/)
 Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 documentation files (the "Software"), to deal in the Software without restriction, including without limitation the
 rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit
 persons to whom the Software is furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all copies or substantial portions of the
 Software.
 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
 WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import {OnDestroy} from "@angular/core";
import {Observable} from "rxjs";
import {DialogWrapperComponent} from "./dialog-wrapper.component";
import {DialogService} from "./dialog.service";
import {Subscriber} from "rxjs/Subscriber";

/**
 * Abstract dialog
 * @template T - dialog data;
 * @template T1 - dialog result
 */
export class DialogComponent<T, T1> implements OnDestroy {
  /**
   * Observer to return result from dialog
   */
  protected subscriber: Subscriber<T1>;

  /**
   * Dialog result
   * @type {T1}
   */
  result: T1;

  /**
   * Dialog wrapper (modal placeholder)
   */
  wrapper: DialogWrapperComponent;

  /**
   * Constructor
   * @param {DialogService} dialogService - instance of DialogService
   */
  constructor(protected dialogService: DialogService) {}

  /**
   *
   * @param {T} data
   * @return {Observable<T1>}
   */
  fillData(data: T): Observable<T1> {
    data = data || {} as T;
    const keys = Object.keys(data);
    for (let i = 0, length = keys.length; i < length; i++) {
      const key = keys[i];
      this[key] = data[key];
    }

    this.ready();

    return new Observable<T1>((subscriber: Subscriber<T1>) => {
      this.subscriber = subscriber;

      return () => {
        this.close();
      };
    });
  }

  ready() {}

  /**
   * Closes dialog
   */
  close(): void {
    this.dialogService.removeDialog(this as DialogComponent<any, any>);
  }

  /**
   * OnDestroy handler
   * Sends dialog result to observer
   */
  ngOnDestroy(): void {
    if (this.subscriber) {
      this.subscriber.next(this.result);
      this.subscriber.complete();
    }
  }
}
